import { FaCalendarAlt, FaTasks, FaBullhorn, FaInfoCircle } from "react-icons/fa";

export const NOTIF_LINK_MAP = {
  leave_request: "/leaves",
  regularization: "/attendance",
  task: "/task",
};

export const TAB_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Unread", value: "unread" },
  { label: "Read", value: "read" },
];

export const TYPE_FILTER_OPTIONS = [
  { label: "All Types", value: "" },
  { label: "Leave Submitted", value: "1" },
  { label: "Leave Approved", value: "2" },
  { label: "Leave Rejected", value: "3" },
  { label: "Regularization Submitted", value: "5" },
  { label: "Regularization Approved", value: "6" },
  { label: "Announcement", value: "11" },
  { label: "System", value: "12" },
];

export const PRIORITY_FILTER_OPTIONS = [
  { label: "All Priorities", value: "" },
  { label: "Low", value: "1" },
  { label: "Normal", value: "2" },
  { label: "High", value: "3" },
  { label: "Urgent", value: "4" },
];

export const ANNOUNCEMENT_PRIORITY_OPTIONS = [
  { label: "Low", value: "1" },
  { label: "Normal", value: "2" },
  { label: "High", value: "3" },
  { label: "Urgent", value: "4" },
];

export const formatRelativeTime = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";
  const diffMs = Date.now() - date.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return "Just now";
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 7) return `${diffDay}d ago`;
  return date.toLocaleDateString();
};

export const getPriorityBadgeClass = (priority) => {
  switch (priority) {
    case 4:
      return "priority-badge urgent";
    case 3:
      return "priority-badge high";
    case 1:
      return "priority-badge low";
    default:
      return "priority-badge normal";
  }
};

export const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  const initials = parts.length > 1 ? `${parts[0][0]}${parts[1][0]}` : parts[0].slice(0, 2);
  return initials.toUpperCase();
};

export const getTypeIcon = (type) => {
  switch (type) {
    case 1:
    case 2:
    case 3:
    case 4:
      return <FaCalendarAlt className="notif-type-icon leave" />;
    case 5:
    case 6:
    case 7:
      return <FaCalendarAlt className="notif-type-icon regularization" />;
    case 9:
    case 10:
      return <FaTasks className="notif-type-icon task" />;
    case 11:
      return <FaBullhorn className="notif-type-icon announcement" />;
    default:
      return <FaInfoCircle className="notif-type-icon system" />;
  }
};